import { ROLES as R } from "../core/roles";
import { lud, rule } from "../core/rule";

// LUD Copilot support inbox. Mirrors the backend (copilotAccess.js):
//   ceo / cto / developer   every permission, every conversation
//   am / dm / dmm           view, reply, change status and statistics, only for
//                           conversations of their restaurants or assigned to them
//   everyone else           no access
// The backend enforces these (and the conversation scope) on every request; this
// only decides what the UI offers. Roles without `copilot.view` get no sidebar
// entry, no badge, no unresolved-count request and no route.
// The customer-side widget is not governed here: it is open to everyone.
export const copilotPermissions = {
  view: "copilot.view",
  nav: "copilot.nav",
  reply: "copilot.reply",
  changeStatus: "copilot.changeStatus",
  assign: "copilot.assign",
  stats: "copilot.stats",
  manageReplies: "copilot.manageReplies",
  manageSettings: "copilot.manageSettings",
  manageFaqs: "copilot.manageFaqs",
};

const AGENTS = lud(R.AM, R.DM, R.DMM);

export const copilotGrants = {
  "copilot.view": rule(AGENTS),
  "copilot.nav": rule(AGENTS),
  "copilot.reply": rule(AGENTS),
  "copilot.changeStatus": rule(AGENTS),
  // reassigning is a management action (ceo-level only)
  "copilot.assign": rule(lud()),
  "copilot.stats": rule(AGENTS),
  // creating / editing / archiving the shared saved replies (everyone who can reply may use them)
  "copilot.manageReplies": rule(lud()),
  // editing the automatic first replies (the backend's copilot.manage_settings)
  "copilot.manageSettings": rule(lud()),
  // creating, editing, ordering, activating and deleting the chat's FAQs (the backend's copilot.manage_faqs)
  "copilot.manageFaqs": rule(lud()),
};
